// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9e9b2d81","223":"c6c5712e","488":"070e6281","667":"3048cb0d"}[chunkId] + ".chunk.js";
};